var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCircleProgressQueue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2426 4.75736C12.6855 4.20021 12.0241 3.75825 11.2961 3.45672C10.5681 3.15519 9.78793 3 9 3C8.21207 3 7.43185 3.15519 6.7039 3.45672C5.97594 3.75825 5.31451 4.20021 4.75736 4.75736L9 9L13.2426 4.75736Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75736 13.2426C5.31451 13.7998 5.97595 14.2417 6.7039 14.5433C7.43185 14.8448 8.21207 15 9 15C9.78793 15 10.5681 14.8448 11.2961 14.5433C12.0241 14.2417 12.6855 13.7998 13.2426 13.2426L9 9L4.75736 13.2426Z",
    fill: "#CFCFCF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleProgressQueue);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;